// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--11-1!../../../node_modules/postcss-loader/lib/index.js??ref--11-2!../../../node_modules/stylus-loader/index.js??ref--11-3!./varibles.styl");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("189678a2", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/varibles.styl
// module id = Z7xA
// module chunks = 61